import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox,
  ContentContainer,
  FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import SimplePicker from 'Helpers/SimplePicker';
import IncludedScenarioChart from 'Components/ComponentLibrary/Organisms/IncludedScenarioChart';
import IncludedNextUpSummary from 'Components/ComponentLibrary/Organisms/IncludedNextUpSummary';

const ScenarioActivationQuestionStepTemplateContent = ({ resource }) => {
  const subtitle = (Array.isArray(resource.attr('subtitle'))) ? resource.attr('subtitle').join(' ') : resource.attr('subtitle');

  return (
    <FDBox margin={400}>
      <ContentContainer maxWidth={'sm'}>
        <FDStack direction={'column'} alignItems={'center'} spacing={3} justifyContent="flex-start">
          <Title text={resource.attr('title')} test="wizard-step-title" />
          <Subtitle
            text={subtitle}
            test="wizard-step-subtitle"
          />
          <SimplePicker
            resource={resource}
            relationship={fr.relationships.facetPlanChartData.name}
            hasRelationship={({ relationship }) => (
              <IncludedScenarioChart relationship={relationship} />
            )}
          />
          <SimplePicker
            resource={resource}
            relationship={fr.relationships.nextUpSummaryTimeline.name}
            hasRelationship={({ relationship }) => (
              <IncludedNextUpSummary relationship={relationship} />
            )}
          />
        </FDStack>
      </ContentContainer>
    </FDBox>
  );
};

ScenarioActivationQuestionStepTemplateContent.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioActivationQuestionStepTemplateContent;
